import React, { useContext, useState, useEffect } from "react";
import { Collapse, Navbar, Nav, Row, Col } from "reactstrap";
import classNames from "classnames";
import AppContext from "../../context/Context";
import Logo from "./Logo";
import SearchBox from "./SearchBox";
import TopNavRightSideNavItem from "./TopNavRightSideNavItem";
import NavbarTopDropDownMenus from "./NavbarTopDropDownMenus";
import { navbarBreakPoint, topNavbarBreakpoint } from "../../config";
import autoCompleteInitialItem from "../../data/autocomplete/autocomplete";
import ModalCustom from "../common/ModalCustom";
import ButtonIcon from "../common/ButtonIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserLock } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import apiCall from "../../services/apiCall";

const NavbarTop = () => {
  const {
    showBurgerMenu,
    setShowBurgerMenu,
    isTopNav,
    isVertical,
    isCombo,
    isDark,
    navbarCollapsed,
    setNavbarCollapsed,
    loginUserDetails,
  } = useContext(AppContext);
  const handleBurgerMenu = () => {
    isTopNav && !isCombo && setNavbarCollapsed(!navbarCollapsed);
    (isCombo || isVertical) && setShowBurgerMenu(!showBurgerMenu);
  };

  const history = useHistory();

  // const [is2faModelOpen, setIs2faModelOpen] = useState(false);

  const ApiPlanUpdateCount = async () => {
    // request_plan_update_user
    let params = {
      devid: loginUserDetails.dev_id,
    };
    await apiCall
      .servertrip("GET", "request_plan_update", loginUserDetails,params)
      .then((res) => {
        const items = res.data?.items;
        sessionStorage.setItem("api_plan_update_counts", items.length);
        // return items;
      }).catch((e)=>{
        sessionStorage.removeItem("api_plan_update_counts");
      });
  };


  useEffect(() => {
    // user_acccess_list
    if (loginUserDetails.is_partner == "0" && loginUserDetails["user_acccess_list"]?.includes("liApiSubscriptionComponent") ) {
      ApiPlanUpdateCount();
    }
  }, []);



  return (
    <Navbar
      // style={{ zIndex: 2000 }}
      light
      className={classNames(
        "navbar-glass fs--1 font-weight-semi-bold row navbar-top sticky-kit mr-0",
        {
          ["navbar-glass-light"]: isDark == 0,
        },
        {
          ["navbar-glass-dark"]: isDark == 1,
        }
      )}
      expand={isTopNav && topNavbarBreakpoint}
    >
      <div
        className={classNames("toggle-icon-wrapper mr-md-3 mr-2", {
          "d-lg-none": isTopNav && !isCombo,
          [`d-${navbarBreakPoint}-none`]: isVertical || isCombo,
        })}
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </div>
      <Logo at="navbar-top" width={150} height={30} id="topLogo" />
      {isTopNav ? (
        <Collapse navbar isOpen={navbarCollapsed} className="scrollbar">
          <Nav navbar>
            <NavbarTopDropDownMenus setNavbarCollapsed={setNavbarCollapsed} />
          </Nav>
        </Collapse>
      ) : null
      //  (
      //   <Nav navbar className={`align-items-center d-none d-${topNavbarBreakpoint}-block`}>
      //     <NavItem>
      //       <SearchBox autoCompleteItem={autoCompleteInitialItem} />
      //     </NavItem>
      //   </Nav>
      // )
      }
      {/* <div className="px-auto font-weight-semi-bold" style={{textAlign:"center"}}>
      <p className="animate-charcter py-0">Are your patients unhappy with the payment solutions you offer? World class speakers and useful solutions that you can immediately apply. Virtual meeting on October 6. Payments in Healthcare. Register today.  <a href="https://summit.sikkasoft.com/"
        target="_blank" 
       >https://summit.sikkasoft.com</a>
        </p>
      </div> */}
      <TopNavRightSideNavItem />
    </Navbar>
  );
};

export default NavbarTop;
